import { SmartMentionResource, type SmartMentionConfig } from '@atlassian/smart-mention-resource';

import {
	RovoChatMentionResource,
	type RovoChatMentionResourceConfig,
} from './rovo-chat-mention-resource';

/** Config for the path where this package builds the underlying SMR.
 *  Hosts owning their own SMR singleton construct `RovoChatMentionResource` directly. */
export type CreateRovoChatMentionResourceParams = Omit<
	RovoChatMentionResourceConfig,
	'peopleResource'
> & {
	peopleConfig: SmartMentionConfig;
};

/** Builds a `RovoChatMentionResource` that owns the underlying SMR's lifecycle. */
export const createRovoChatMentionResource = (
	params: CreateRovoChatMentionResourceParams,
): RovoChatMentionResource => {
	const { peopleConfig, ...rest } = params;
	const peopleResource = new SmartMentionResource(peopleConfig);
	const resource = new RovoChatMentionResource({
		peopleResource,
		...rest,
	});
	return resource;
};
